import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from '@structural-climbing/ui'
import { SETUP_STEPS, type Stage } from './steps'

/**
 * Before, during and after: the three stages of a competition's page.
 *
 * Running and After open once the competition is published. Until then there
 * is nobody to list and nothing to score, so they are greyed rather than empty.
 */
export function StagesBar({
  stage,
  onChange,
  doneSteps,
  published,
  ended,
}: {
  stage: Stage
  onChange: (stage: Stage) => void
  doneSteps: number
  published: boolean
  ended?: boolean
}) {
  const { t } = useTranslation()
  const setupDone = doneSteps === SETUP_STEPS.length
  return (
    <Tabs
      aria-label={t('competitionSetup.stagesLabel')}
      selectedKey={stage}
      onSelectionChange={(key) => onChange(String(key) as Stage)}
      disabledKeys={published ? [] : ['live', 'after']}
      classNames={{
        base: 'max-w-full',
        tabList: 'max-w-full overflow-x-auto scrollbar-hide gap-1 bg-default-100 p-1',
        tab: 'w-auto px-4 h-10',
        cursor: 'bg-content1 shadow-sm',
        tabContent:
          'text-foreground/70 group-data-[selected=true]:font-semibold group-data-[selected=true]:text-foreground',
      }}
    >
      <Tab
        key="setup"
        title={
          setupDone ? (
            <span>
              {t('competitionSetup.stageSetup')} <span className="text-success">✓</span>
            </span>
          ) : (
            t('competitionSetup.stageProgress', {
              stage: t('competitionSetup.stageSetup'),
              done: doneSteps,
              total: SETUP_STEPS.length,
            })
          )
        }
      />
      <Tab
        key="live"
        title={
          ended ? (
            <span>
              {t('competitionSetup.stageLive')} <span className="text-success">✓</span>
            </span>
          ) : (
            t('competitionSetup.stageLive')
          )
        }
      />
      <Tab key="after" title={t('competitionSetup.stageAfter')} />
    </Tabs>
  )
}
